import { render, staticRenderFns } from "./payables-payments.vue?vue&type=template&id=7bcdb5e0"
import script from "./payables-payments.vue?vue&type=script&lang=js"
export * from "./payables-payments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports